import PropTypes from 'prop-types';
import React from 'react';
import {withApollo} from 'react-apollo';
import {Redirect, Route} from 'react-router-dom';
import {logout} from '../../utils';
import {AUTH_TOKEN_ACCESS} from '../../common/constants';
import {withLoadedUser} from './AuthBase';

const AuthRoute = withApollo(withLoadedUser(
  ({roles, redirect = '/login', client, component: Component, currentUser, ...rest}) => {
    const [noToken, setNoToken] = React.useState(false);
    React.useEffect(() => {
      const handleInvalidToken = e => {
        if (e.key === AUTH_TOKEN_ACCESS && e.oldValue && !e.newValue) {
          setNoToken(true);
        }
      };

      window.addEventListener('storage', handleInvalidToken);

      return () => {
        setNoToken(false);
        window.removeEventListener('storage', handleInvalidToken);
      };
    });

    if (noToken) {
      logout(client);
      return <Redirect to='/login' />;
    }

    const RenderComponent = props => {
      return isRoleMatch(roles, currentUser) ? (
        <Component currentUser={currentUser} {...props} {...rest} />
      ) : (
        <Redirect to={{pathname: redirect}} />
      );
    };

    return <Route {...rest} render={RenderComponent} />;
  },
));

AuthRoute.propTypes = {
  role: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  redirect: PropTypes.string,
};

const isRoleMatch = (role, currentUser) => {
  if (!role) {
    return true;
  }
  return currentUser && (Array.isArray(role) ? role : [role]).includes(currentUser.role);
};

export * from './AuthBase';
export {AuthRoute};
